// extracted by mini-css-extract-plugin
export default {"positive":"TrendIndicator_positive__KdAUZ","negative":"TrendIndicator_negative__vSRkM"};